module.exports = __webpack_public_path__ + "img/cta-arrow.594855dd.svg";